<template>
  <div id="HomeHeader">
  
      <header>
        <nav class="text-white">
          <div class="container px-20 mx-auto md:flex md:items-center">
            <div class="header-logo">
              <a href="#">
              </a>
            </div>

            <div 
              class="menu-list navbar-collapse w-100 md:w-100 hidden md:flex flex-col md:flex-row md:ml-auto text-right md:text-right -right-full md:right-auto duration-500 delay-500"
            >
              <a href="#menu-1" class="p-2 py-4 px-4">menu-1</a>
              <a href="#menu-2" class="p-2 py-4 px-4">menu-2</a>
              <a href="#menu-3" class="p-2 py-4 px-4">menu-3</a>
              <a href="#menu-4" class="p-2 py-4 px-4">menu-4</a>
            </div>
          </div>
        </nav>
      </header>

      <!-- mobile -->
      <div class="menu-mobile" @click="showMenu = !showMenu">
        <svg v-if="!showMenu" xmlns="http://www.w3.org/2000/svg" class="h-8 w-8" fill="none" viewBox="0 0 24 24" stroke="currentColor">
          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M4 6h16M4 12h16M4 18h16" />
        </svg>
        <svg v-else xmlns="http://www.w3.org/2000/svg" className="h-8 w-8" fill="none" viewBox="0 0 24 24" stroke="currentColor">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
        </svg>
      </div>
      <div class="container-mobile" v-show="showMenu">
        <div class="list-links">
          <div class="header">
          </div>
          
          <a href="#menu-1" @click="showMenu = false">menu-1</a>
          <a href="#menu-2" @click="showMenu = false">menu-2</a>
          <a href="#menu-3" @click="showMenu = false">menu-3</a>
          <a href="#menu-4" @click="showMenu = false">menu-4</a>
          
        </div>
      </div>
  </div>
</template>
<script>
import Modal from "@/components/Parts/Modal";

export default {
  name: 'HomeHeader',
  data: () => ({
    showMenu: false,
    ModalPolitica: false,
    ModalRegulamento: false,
    politicaHtml: "",
    regulamentoHtml: ""
  }),
  components: {
    Modal
  },
  computed:{
    modalContactUs: {
      get() {
        return this.$store.getters.modalContactUs;
      },
      set(value) {
        this.$store.commit('showModalContactUs', value)
      }
    }
  },
  methods:{
    goHome(mobile){
      
      if(mobile){
        this.showMenu = false;
      }
    },
  },
  created(){
  }
}
</script>
